import {useState,useEffect} from 'react';
import {TableContainer,Table,TableBody,TableRow,TableHead,TableCell,FormText,LegendBox,LegendText} from '../styles/ExamStyle.js'
import { LoadingIcon, Container,BackButton} from '../styles/style.js';
import Portal from '../API/Portal.js';
import { useDispatch,useSelector} from 'react-redux';
import { setExamLink, setExamType,setFormList,setCompletedForms,setTriageScore,setExamPassword,resetState} from '../redux/ExamSlice.js';
import { setForms } from '../redux/UserSlice.js';
import LinkExam from './LinkExam';
import WriteDB from '../API/WriteDB.js';

const writeDB = new WriteDB();
const portal = new Portal();
export default function Exams(){
    const [loading,setLoading] = useState(true);
    const [exams,setExams] = useState([]);
    const [showExam,setShowExam] = useState(false);
    const link = useSelector((state)=>state.exam.link)
    const completedForms = useSelector((state)=>state.exam.completedForms)
    const dispatch = useDispatch();

    useEffect(()=>{
        const fetchExams = async()=>{
            setExams(await portal.readExams());
            setLoading(false)
        }
        fetchExams();
    },[])

    function getRows(){
        var rows = [];
        for(let i = 0;i < exams.length;i++){
            var formList = [];
            for(let j = 0;j < exams[i].formList.length;j++){
                var textClass = 'done'
                if(exams[i].completedForms === undefined || !exams[i].completedForms.includes(exams[i].formList[j])){
                    textClass = 'incomplete'
                }
                formList.push(
                    <>
                        <FormText className={textClass}>{exams[i].formList[j]}</FormText>
                        {j !== exams[i].formList.length - 1 &&
                            <FormText>, </FormText>
                        }
                    </>
                )
            }

            rows.push(
                <TableRow onClick={()=>{selectExam(exams[i])}}>
                    <TableCell>{exams[i].type}</TableCell>
                    <TableCell>{formList}</TableCell>
                </TableRow>
            )
        }
        return rows;
    }

    function selectExam(exam){
        dispatch(setExamLink(exam.link))
        dispatch(setCompletedForms(exam.completedForms === undefined ? [] : exam.completedForms))
        dispatch(setExamType(exam.type));
        dispatch(setTriageScore(exam.tempTriage === undefined ? 0 : exam.tempTriage))
        dispatch(setFormList(exam.formList))
        dispatch(setExamPassword(exam.password))
        setShowExam(true)
    }

    async function handleExit(){
        await writeDB.deleteLink();
        var index = 0;
        for(let i = 0;i < exams.length;i++){
            if(exams[i].link === link){
                index = i;
                break;
            }
        }

        exams[index].completedForms = completedForms;
        dispatch(resetState())
        var response  = await portal.readForms();
        if(response !== 'Read Forms Error'){
            dispatch(setForms(response))
        }
        setShowExam(false);
    }

    if(loading){
        return(
            <Container>
                <LoadingIcon className="fas fa-spinner"></LoadingIcon>
            </Container>
        )
    }else{
        return(
            <>
                {!showExam &&
                    <>
                        <Container>
                            <LegendBox className='incomplete'/>
                            <LegendText>Incomplete</LegendText>
                            <LegendBox className='done'/>
                            <LegendText>Done</LegendText>
                        </Container>

                        <TableContainer>
                            <Table>
                                <TableBody>
                                    <TableRow>
                                        <TableHead>Type</TableHead>
                                        <TableHead>Forms</TableHead>
                                    </TableRow>
                                    {getRows()}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </>
                }

                {showExam &&
                    <>
                        <BackButton onClick={handleExit}></BackButton>
                        <LinkExam type='clientPortal' examDone={handleExit}></LinkExam>
                    </>        
                }
            </>
        )
    }
    
}